import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPresence = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M22 20.1538C22 20.3579 21.919 20.5535 21.7747 20.6978C21.6304 20.842 21.4348 20.9231 21.2308 20.9231H2.76923C2.56522 20.9231 2.36956 20.842 2.2253 20.6978C2.08104 20.5535 2 20.3579 2 20.1538V4.76923C2 4.56522 2.08104 4.36956 2.2253 4.2253C2.36956 4.08104 2.56522 4 2.76923 4C2.97324 4 3.1689 4.08104 3.31316 4.2253C3.45742 4.36956 3.53846 4.56522 3.53846 4.76923V15.2212L8.375 10.375C8.52084 10.2306 8.71781 10.1495 8.92308 10.1495C9.12834 10.1495 9.32531 10.2306 9.47115 10.375L12 12.9135L17.8365 7.07692H15.8462C15.6421 7.07692 15.4465 6.99588 15.3022 6.85162C15.158 6.70736 15.0769 6.51171 15.0769 6.30769C15.0769 6.10368 15.158 5.90802 15.3022 5.76376C15.4465 5.61951 15.6421 5.53846 15.8462 5.53846H19.6923C19.8963 5.53846 20.092 5.61951 20.2362 5.76376C20.3805 5.90802 20.4615 6.10368 20.4615 6.30769V10.1538C20.4615 10.3579 20.3805 10.5535 20.2362 10.6978C20.092 10.842 19.8963 10.9231 19.6923 10.9231C19.4883 10.9231 19.2926 10.842 19.1484 10.6978C19.0041 10.5535 18.9231 10.3579 18.9231 10.1538V8.16346L12.5481 14.5481C12.4022 14.6925 12.2053 14.7736 12 14.7736C11.7947 14.7736 11.5978 14.6925 11.4519 14.5481L8.92308 12.0096L3.53846 17.3942V19.3846H21.2308C21.4348 19.3846 21.6304 19.4657 21.7747 19.6099C21.919 19.7542 22 19.9498 22 20.1538Z",
		fill: "#1F4C5C"
	})]
});
const ForwardRef = forwardRef(SvgPresence);
export { ForwardRef as ReactComponent };
